/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Uploadprospectscsv3Inputs */

const en_coinvestments_uploadprospectscsv3 = /** @type {(inputs: Coinvestments_Uploadprospectscsv3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload Prospects (CSV)`)
};

/**
* | output |
* | --- |
* | "Upload Prospects (CSV)" |
*
* @param {Coinvestments_Uploadprospectscsv3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_uploadprospectscsv3 = /** @type {((inputs?: Coinvestments_Uploadprospectscsv3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Uploadprospectscsv3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_uploadprospectscsv3(inputs)
});
export { coinvestments_uploadprospectscsv3 as "coInvestments_uploadProspectsCsv" }